module.exports = __webpack_public_path__ + "88a655219cbaf398589fdc6d08a3557c.MP3";